export default __webpack_public_path__ + "images/4U.6a1cf26.png";